export default __webpack_public_path__ + "static/scroll-02-ef5685c1087816fce2f97cecc9c06043.jpg";